import { createContext } from 'react';

const context = createContext({
	contentGlobal: [],
	filtersGlobal: [],
	mediaGlobal: [],
	additionalGlobal: [],
	triggerRefresh: false,
	fetchData: () => {},
});

export default context;
